import { MainContextProvider } from 'utils/context';
import Navbar from 'components/navbar/navbar';
import { Route, Routes, Navigate } from 'react-router-dom';
import Authenticate from 'pages/authenticate';
import { useState, useEffect } from 'react';
import Quizs from 'pages/quizs';
import { auth, database } from 'utils/firebaseConfig'; // Import Firestore database
import { useAuthState } from "react-firebase-hooks/auth";
import Quizdata from 'pages/showQuiz';
import AddQuiz from 'pages/addQuiz';
import { doc, onSnapshot } from "firebase/firestore"; // Import Firestore functions
import Admin from 'components/Admin/admin';
import EditQuiz from './components/Admin/EditQuiz';
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner';
import './App.scss';

export default function App() {
  const [user, loading] = useAuthState(auth);
  const [isAdmin, setIsAdmin] = useState(false);
  const [error, setError] = useState("");
  const [selectedTab, setSelectedTab] = useState("");
  const [userId, setUserId] = useState(null);
  const [isInitializing, setIsInitializing] = useState(true);

  // تحديث userId عندما يتغير المستخدم
  useEffect(() => {
    if (user) {
      setUserId(user.uid);
    } else {
      setUserId(null);
    }
  }, [user]);

  // جلب حالة المدير من Firestore
  useEffect(() => {
    if (user) {
      const userDocRef = doc(database, "users", user.uid);

      const unsubscribe = onSnapshot(
        userDocRef,
        (userDoc) => {
          if (userDoc.exists()) {
            setIsAdmin(userDoc.data().isAdmin);
          } else {
            setError("User data not found. Please contact support.");
          }
          setIsInitializing(false);
        },
        (error) => {
          setError("Error fetching user data: " + error.message);
          setIsInitializing(false);
        }
      );

      return () => unsubscribe();
    } else {
      setIsAdmin(false);
      setIsInitializing(false);
    }
  }, [user]);

  // تجميع كل القيم التي سنمررها للسياق
  const contextValue = {
    user,
    isAdmin,
    loading: loading || isInitializing,
    userId,
    selectedTab,
    setSelectedTab,
    error
  };

 

  return (
    <MainContextProvider value={contextValue}>
      <div className="app-container">
        <Navbar />
        {error && <div className="error-message">{error}</div>}
        <main className="main-content">
          <Routes>
            <Route path='/' element={<Quizs />} />
            <Route
              path='/addQuiz'
              element={
                user && isAdmin ? <AddQuiz /> : <Navigate to='/' />
              }
            />
            <Route
              path='/authenticate'
              element={
                user ? <Navigate to='/' /> : <Authenticate />
              }
            />
            <Route path='/showQuiz/:id' element={<Quizdata />} />
            <Route 
              path="/admin" 
              element={
                user && isAdmin ? <Admin /> : <Navigate to='/' />
              } 
            />
            <Route 
              path="/edit-quiz/:quizId" 
              element={
                user && isAdmin ? <EditQuiz /> : <Navigate to='/' />
              } 
            />
            <Route path='*' element={<Navigate to='/' />} /> {/* مسار لجميع الصفحات غير المعروفة */}
          </Routes>
        </main>
      </div>
    </MainContextProvider>
  );
}